import { createSelector } from '@ngrx/store';

import { BusinessOperatingSystem } from '@ninety/platform/models/company/business-operating-system.enum';
import { MazStatus } from '@ninety/platform/models/maz/maz-status.enum';
import {
  FeatureFlagKeys,
  selectFeatureFlag,
  selectBos,
  selectCurrentPerson,
  selectCurrentUser,
} from '@ninety/platform/state';

import { selectMazState } from '../../_state';

export namespace MazSelectors {
  export const selectUserMazStatusEnabled = createSelector(
    selectCurrentPerson,
    ({ mazStatus }) => mazStatus !== MazStatus.DISABLED
  );
  export const selectMazChatEnabled = createSelector(
    selectFeatureFlag(FeatureFlagKeys.mazChat),
    selectFeatureFlag(FeatureFlagKeys.mazChat90os),
    selectBos,
    selectUserMazStatusEnabled,
    (mazChatFlag, mazChat90osFlag, bos, userEnabledMazChat) =>
      bos === BusinessOperatingSystem.ninetyOS
        ? mazChat90osFlag && userEnabledMazChat
        : mazChatFlag && userEnabledMazChat
  );
  export const selectIsMazChatExpanded = createSelector(selectMazState, state => state.mazChatExpanded);
  export const selectCommonQuestions = createSelector(selectMazState, state => state.commonQuestions);
  export const selectDescription = createSelector(selectMazState, state => state.description);
  export const selectConversationHistory = createSelector(selectMazState, state => state.mazMessages);
  export const selectWaitingForMazResponse = createSelector(selectMazState, state => state.waitingForMazResponse);

  export const selectShowMazChatToggle = createSelector(
    selectFeatureFlag(FeatureFlagKeys.mazChat),
    selectCurrentUser,
    (mazChatFlag, user) => mazChatFlag && user?.guideEnabled
  );
}
